const zh = {
  swap: '交易',
  markets: '市场',
  comingSoon: '即将推出',

  header: {
    buyToken: '购买代币',
    searchTokens: '搜索代币',
    recentSearches: '最近搜索',
    popularTokens: '热门代币',
    noSearchContent: '暂无搜索内容',
    markets: '市场'
  },

  appSetting: {
    theme: '主题',
    light: '浅色主题',
    dark: '深色主题',
    auto: '跟随系统',

    language: '语言',
    langText: '中文',

    showChart: '市场行情',
    contactUs: '联系我们',
  },

  stake: {
    know: {
      title: '抵押 TPT 获得 xTPT',
      desc: '抵押 TPT 获得 xTPT, xTPT 可以用于生态提案的投票。 你可以随时兑换TPT 与 xTPT，目前仅支持BSC链的TPT。 更多链陆续上线中...',
    },
    join: '已抵押 TPT',
    connectWallet: '连接钱包',
    networkNotvalid: '请切换到BSC网络',
    approve: '授权',
    unstake: '解押',
    add: '增加',
    loginFirst: '请先连接钱包',
    deposit: '抵押 TPT',
    withdraw: '解押 TPT',
    balance: '余额',
    confirm: '确认',
    overbalance: '超过可用余额',
    success: '操作成功',
    all: '全部',
    voteTip: '使用 xTPT 来投票你支持的提案!',
    goVote: '去投票',
  },

  fee: {
    desc: 'Transit Swap上线聚合交易手续费折扣功能，根据用户账户地址持有的TPT与xTPT数量的总和对应的折扣率进行手续费折扣。当前折扣等级分为4级，将来根据实际情况，进行更多层级拆分。',
    feeDiscount: '费率折扣',
    walletBalance: '钱包余额',
    levelRank: '等级',
    levelBalance: '余额（TPT及xTPT)',
    levelDiscountRate: '折扣率',
  },

  donation: {
    know: {
      title: 'Transit Swap捐赠池定义：',
      desc: '作为开放的区块链世界的一份子，Transit Swap项目接受来自个人用户的Token捐赠，所有捐赠将进入捐赠池，池内资金将用于包括但不限于Transit Swap项目运营与对Transit Swap相关生态的资助。',
    },
    tip: {
      title: '重要提示：',
      desc: 'Transit Swap项目不会对捐赠者有确定性的回报与奖励；在捐赠哈希72小时内，希望退回捐赠的捐赠者可通过官方联系方式提出原路返还要求，超过这一时限的返还要求将不被处理。',
    },
    donateType: {
      title: '我们接受的捐赠代币种类：',
      desc: 'TPT',
    },
    address: {
      title: '接受捐赠的地址：',
    },
    join: '参与捐赠',
    donateChain: '选择捐赠的链',
    connectWallet: '连接钱包',
    donateTip: {
      title: '注：',
      desc: '在捐赠哈希72小时内，希望退回捐赠的捐赠者可通过官方联系方式提出原路返还要求，超过这一时限的返还要求将不被处理。',
    },
    warn: '请先选择捐赠的链',
    transfer: '请使用TokenPocket扫描该二维码进行TPT捐赠',
    copyAddress: '复制地址',
    copied: '复制成功',
    yourAddress: '您的地址',
    cantDonate: '当前链不支持捐赠',
    confirmDonate: '确定捐赠',
    donateSuccess: '捐赠成功',
    donateFail: '捐赠失败',
    overCount: '余额不足',
    donateAddress: '捐赠地址',
    donateCount: '捐赠数量 (TPT)',
    pleaseSwitch1: '请切换到',
    pleaseSwitch2: '网络',
    downloadTP: '无法直接捐赠，请下载TokenPocket钱包',
    connectTronLink: '请先连接TronLink钱包',
    waitBlockConfirm: '提交成功',
    noZero: '捐赠数量不能为0',
  },

  home: {
    title_1: '凭借强大且先进的DEX平台',
    title_2: '让你更专业地交易',
    swap: '闪兑',
    bridge: '跨链',
    startTrading: '开启交易',
    viewMore: '了解更多',
    modal_contact_us: {
      title: '联系方式',
      text_1:
        '* 请注意，Transit团队绝不会主动联系您，我们也不会要求您支付任何费用。',
    },
    markets: {
      title: '市场',
      text: '获取实时数据，发现热门代币，并通过市场 &#128200;&#128201; 功能做出更智慧的交易决策。',
      text_1: '即将推出'
    },
    onRamp: {
      title: '购买',
      text: '通过多个出入金渠道，让您选择最优的价格实现加密资产的购买和出售。',
    },
    swap_bridge: {
      title: '闪兑&跨链',
      text: '汇聚头部DEXs，在多个链上以最佳价格和顶尖的专业水平进行交易优化。此外，我们提供专业的跨链桥服务，确保您的资产流动性无缝连接。',
    },
    liquidity_options: {
      title: '数据',
      text_1: '更好的流动性,',
      text_2: '更好的选择',
      Chains: '公链',
      DEXs: 'DEX',
      Bridges: '跨链桥',
      Ramps: '法币渠道',
      Tokens: '代币',
    },
    other_features: {
      title: '其他',
      NFT: {
        title: 'NFT',
        text_1: 'NFT市场',
        text_2: 'Transit NFT',
        text_3: 'NFT设计大赛',
      },
      NFT: {
        title: '治理',
        text_1: 'DAO',
        text_2: '捐赠',
        text_3: '费率',
      },
    },
    get_start: {
      text_1: '通过 Transit 解锁交易的无限可能',
      text_2: '让你的交易更专业!',
      text_3: '立即开启',
    },
  },

  footer: {
    Features: {
      title: '功能',
      swap: '闪兑',
      bridge: '跨链桥',
      market: '市场行情',
      buyCrypto: '购买',
      explorer: '浏览器',
    },
    NFT: {
      title: 'NFT',
      design: '设计大赛',
      transitNFT: 'Transit NFT',
      marketplace: 'NFT市场',
    },
    Governance: {
      title: '治理',
      dao: 'DAO',
      donation: '捐赠',
      fee: '费率',
    },
    Community: {
      title: '社区',
      developers: '开发者',
      forum: '论坛',
      twitter: 'Twitter',
      downloadTP: '下载 TP',
    },
    Help: {
      title: '帮助',
      contactUs: '联系我们',
      helpCenter: '帮助中心',
    },
  },
};

export default zh;
